<template>
<!-- 省市区 -->
    <div class="left-menu" ref="leftMenu">
        <!-- 舆情分析 -->
        <div class="inside" v-if="$route.meta.pageType === 0">
            <div class="left-fang">
                <div class="btn-warp clearfix">
                    <router-link class="fl"  v-if="userInfo.isAdmin" :to="{path:'/analysis/buildSolution'}"><button class="btn build btn-jbblue"><i class="icons add-icon"></i>新建</button></router-link>
                    <button class="btn  btn-border-blue fr" :class="userInfo.isAdmin==1 ? 'switch': 'switch1'" @click="selectPlan();">切换方案</button>
                </div>
                <div class="text clearfix" v-if="$parent.isPlan!= ''">
                    <i class="icons fa-icon fl"></i>
                    <router-link class="href fr" v-if="userInfo.isAdmin" :to="{path:'/analysis/buildSolution',query:{'planId':$parent.isPlan.id}}" title="编辑当前方案"><i class="icons edit-icon3"></i></router-link>
                    <a class="href fr" href="javascript:void(0);" @click="openKeywordsMatching();" title="选择查看范围"><i class="icons select-icon"></i></a>
                    <span class="ovhidden db">{{$parent.isPlan.name}}</span>
                </div>
            </div>
            <ul class="naver">
				<li v-for="(item,index) in $parent.company.config.leftMenus" :key="index" v-if="item.checked">
				    <router-link class="db" v-if="item.url == ''" :to='"/analysis/"+item.key'><i class="icons fl" :class="item.icon"></i>{{item.value}}</router-link>
                    <a class="db" target="_blank" v-else :href="item.url"><i class="icons fl" :class="item.icon"></i>{{item.value}}</a >
				</li>
            </ul>    
        </div>
        <!-- 个人中心 -->
        <div class="inside" v-if="$route.meta.pageType === 4">
            <div class="personal-rank color-8a8a99">
                <img class="img db" :src="$parent.headImg === '' ? 'static/images/headImg.png' : $parent.headImg" onerror="this.src='static/images/headImg.png'"/>
                <div class="user-name mt20 ac">{{$parent.nickname}}</div>
                <!-- <div class="rank ac"><i class="icons" :class="vipIcons[$parent.memberType-1]" v-if="$parent.memberType != 0"></i>{{$parent.memberTypeName}}</div> -->
                <div class="rank ac"><span class="color-white">{{$parent.expireTime}}到期</span></div>
                <!-- <div class="rank ac">剩余短信数：<span class="color-white">{{$parent.remainSmsNum}}</span> 条</div> -->
                <!-- <div class="rank ac">剩余下载量：<span class="color-white">{{$parent.remainDownloadNum}}</span> 条</div> -->
            </div>
            <ul class="naver">
                <li v-for="(item,index) in $parent.company.config.upperRightMenus" :key="index">
                    <router-link v-if="item.type ===2" class="db" :class="$route.meta.shuYu === 'vip'&&index ===0 ? 'router-link-active' : ''" :to='item.url'><i class="icons fl" :class="item.icon"></i>{{item.menuName}}</router-link>
                </li>
            </ul>
        </div>
        <!-- 热点事件 -->
        <div class="inside mt20" v-if="$route.meta.pageType === 2">
            <ul class="naver">
                <li>
                    <router-link class="db" to='/eventsIndex'><i class="icons nav-icon9 fl"></i>事件首页</router-link>
                </li>
                <li>
                    <router-link class="db" to='/eventsKu'><i class="icons nav-icon10 fl"></i>事件库</router-link>
                </li>
                <!-- <li>
                    <router-link class="db" to='/specialKu' :class="$route.meta.shuYu === 'eventSpecia' ? 'router-link-active' : ''"><i class="icons nav-icon11 fl"></i>专题库</router-link>
                </li> -->
            </ul>
        </div>
        <!-- 信息汇总全部 -->
        <div class="inside" v-if="$route.meta.pageType === 6">
            <h3 class="bt color-blue">方案列表</h3>
            <ul class="menus">
                <li class="li" v-for="(item,index) in planShowList[0].schemeList" :key="index">
                    <strong class="title color-blue">{{item.typeName}}</strong>
                    <div>
                        <a v-for="(items,indexs) in item.schemeList" :style="{color:sid===items.id?'#0095eb':'#fff'}" class="link ovhidden" href="javascript:void(0);" :key="indexs" @click="selectEnterPlan(items.id);">{{items.name}}</a>
                    </div>
                </li>
            </ul>    
        </div>
        <!-- 选择方案 -->
        <Dialog ref="planModal" type="normal" width="776" title="选择方案" :modalFoot="false">
            <div slot="mdBox">
                <vue-scroll :ops="ops" style="width:100%;height:420px">
                    <div class="search-warp clearfix">
                        <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                        <div class="hidden"><input class="input-text" v-model="searchQuery" type="text" placeholder="请输入方案名称进行搜索"/></div>
                    </div>
                    <div class="plan-list mt20">
                        <div v-for="(pitem,pindex) in planShowList" :key="pindex">
                            <div class="" v-if="$parent.isLeader == 1"><strong class="tion">{{pitem.typeName}}</strong></div>
                            <div v-if="pitem.schemeList.length>0">
                                <div class="item" :class="$parent.isLeader == 1?'ml20 mt10':''" v-for="(item,index) in pitem.schemeList" :key="index">
                                    <p class="title">
                                        <strong class="tion">{{item.typeName}}</strong>
                                        <a class="icons edit-icon1 tion" title="编辑分类" href="javascript:void(0);" v-if="userInfo.isAdmin" @click="editPlanClassification(item.typeId,item.typeName);"></a>
                                        <a class="icons del-sm-icon tion" title="删除分类" href="javascript:void(0);" v-if="userInfo.isAdmin" @click="delPlanClassification(index,item.typeId);"></a>
                                    </p>
                                    <ul class="plan-ul clearfix">
                                        <li v-for="(items,index) in item.schemeList" :key="index" :class="items.id === $parent.isPlan.id ? 'curr' : ''" @click="enterPlan(items.id,items.name);">
                                            <div class="caozu fr">
                                                <a class="icons edit-icon1" href="javascript:void(0);" title="编辑方案" v-if="userInfo.isAdmin" @click.stop="editPlan(items.id);"></a>
                                                <a class="icons del-sm-icon" href="javascript:void(0);" title="删除方案" v-if="userInfo.isAdmin" @click.stop="delPlan(items.id);"></a>
                                            </div>
                                            <span class="name ovhidden">{{items.name}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-else class="mt10 mb10">暂无方案</div>
                        </div>
                    </div>
                    <div v-if="planShowList.length == 0" class="ac">无相关方案，请换个方案搜索</div>
                </vue-scroll>
            </div>
        </Dialog>
         <!-- 删除提示 -->
        <Dialog ref="delPlanModal" :callback="enterDelPlan" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否删除此方案</p>
            </div>
        </Dialog>
        <!-- 修改分类 -->
		<Dialog ref="shieldModalFn" :callback="shieldModal" width="400">
		    <div slot="mdBox">
		        <input class="input-text" v-model="planNameType" maxlength="7" type="text" placeholder="请输入分类名称（最多7个字）"/>
		    </div>
		</Dialog>
        <!-- 当前方案关键词选择 -->
		<Dialog ref="keywordsMatch" title="选择关键词" :callback="keywordsMatching" type="normal" width="600">
			<div slot="mdBox">
                <div class="checkbox-group nolike clearfix" v-if="$parent.isPlan.keywordsMain&&$parent.isPlan.keywordsMain.length>0">
                    <div class="dif flex-alicent">
                      <label class="checkbox-warp fl mr10" :class="allMainList.indexOf('主体词') != -1 ? 'curr' : ''">
                        <input name="" v-model="allMainList" value="主体词" type="checkbox" @change="allCheck(1)" class="checkbox">
                        <i class="icons checkbox-icon"></i>
                      </label>
                      <p style="clear:both;height:30px;line-height:30px;width:500px;">主体词：</p>
                    </div>
					<label class="checkbox-box" v-for="(item,index) in $parent.isPlan.keywordsMain" :key="index">
						<label class="checkbox-warp fl" :class="keywordsMainSelect.indexOf(item) != -1 ? 'curr' : ''">
							<input name="" v-model="keywordsMainSelect" type="checkbox" :value="item" class="checkbox"> <i class="icons checkbox-icon"></i>
						</label>
						<div class="hidden ac">{{item}}</div>
					</label>
				</div>
				<div class="checkbox-group nolike clearfix" v-if="$parent.isPlan.keywordsFinal&&$parent.isPlan.keywordsFinal.length>0">
                    <div class="dif flex-alicent">
                      <label class="checkbox-warp fl mr10" :class="allMainList.indexOf('分析词') != -1 ? 'curr' : ''">
                        <input name="" v-model="allMainList" value="分析词" type="checkbox" @change="allCheck(2)" class="checkbox">
                        <i class="icons checkbox-icon"></i>
                      </label>
                      <p style="clear:both;height:30px;line-height:30px;width:500px;">分析词：</p>
                    </div>
					<label class="checkbox-box" v-for="(item,index) in $parent.isPlan.keywordsFinal" :key="index">
						<label class="checkbox-warp fl" :class="keywordsSelect.indexOf(item) != -1 ? 'curr' : ''">
							<input name="" v-model="keywordsSelect" type="checkbox" :value="item" class="checkbox"> <i class="icons checkbox-icon"></i></label>
						<div class="hidden ac">{{item}}</div>
					</label>
				</div>
			</div>
		</Dialog>
    </div>
</template>
<script>
import Dialog from './dialog.vue';
import {mapState} from 'vuex';
export default {
    components:{Dialog},
    computed:{
        ...mapState({
            sid: state => state.allInformationSet.sid,
            userInfo: state => state.user.userInfo
        })
    },
    name: "left",
    props: '',
    data() {
        return {
			allMainList: [],
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            searchQuery:'',//方案关键词搜索
            planNameType:'',
            planNameId:'',
            delId:'',//方案删除的ID
            pageType:2, //0是舆情分析 1是事件传播分析 2是热点事件 3是帮助文档 4是个人中心
            vipIcons:['rank-icon3','rank-icon1','rank-icon3','rank-icon5'],//会员等级对照表
            planList:[],//方案列表
            planShowList:[],//方案显示列表
            delReptId:'',//竞对方案删除的ID
            opsHeight:'',
            keywordsSelect:[],//方案关键词选择
            isCreatePlan:false,//判断点击的竞对方案是否改变
            keywordsMainSelect:[]//方案主体词选择
        }
    },
    mounted() {
        // this.getPlanList()
        let that = this;
        that.opsHeight = that.$refs.leftMenu.offsetHeight-81;
        if(that.$route.meta.pageType == 5){
            console.log("12345");
            that.reportPlanAjax();
        }
    },
    methods: {
        // 获取方案列表
        getPlanList (type) {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据');
            that.$api.get('monitor/scheme/list',null,r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.planList = r.data;
                    that.searchPlan(that.searchQuery);
                    if(!type){
                        that.$refs.planModal.showMaskFun();
                    }
                });           
            })
        },
        // 选择方案
        selectPlan () {
            let that = this;
            that.getPlanList();
        },
        // 确定方案
        enterPlan (id,name,from) {
            let that = this;
            let value = {
                id:id, 
                name:name
            };
            that.$api.get('monitor/scheme/change',{id:id},r =>{
                that.$utils.returnCode(r,function(){
                    that.planList = r.data; 
                    that.$refs.planModal.closeMask();
                    that.resetSetItem('planStorage', JSON.stringify(value));
                    if(from){
                        //that.$parent.getCurrplan('/analysis/informationSet');
                    }else{
                        if(that.$route.path === '/analysis/buildSolution'){
                            that.$router.push({path:'/analysis/buildSolution',query:{planId:id}});
                            window.location.reload();
                        }else{
                            window.location.reload();
                        }
                    }
                });           
            })
        },
        //方案信息汇总切换
        selectEnterPlan(id){
            this.$store.dispatch('allInformationSet/changeSid',{sid:id})
        },
        // 删除方案
        delPlan (id) {
            let that = this;
            that.delId = id;
            that.$refs.delPlanModal.showMaskFun();
        },
        // 确认删除
        enterDelPlan () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/scheme/delete',{id:that.delId},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功');
                    if(that.$parent.isPlan.id == that.delId){//删除的方案是当前方案会刷新页面
                        location.reload();
                        return;
                    }
                    if(r.data.length === 0){//方案全部删除完
                        that.$parent.getCurrplan();
                        that.$refs.planModal.closeMask();
                        return;
                    }
                    that.planList = r.data;
                    that.searchPlan(that.searchQuery);
                    that.$refs.delPlanModal.closeMask();
                    that.$refs.planModal.showMaskFun();
                });           
            })
        },
        // 添加方案分类
		editPlanClassification (id,name) {
		    let that = this;
			that.planNameId = id;
			that.planNameType = name;
		    that.$refs.shieldModalFn.showMaskFun();
		},
		// 确认添加方案分类
		shieldModal () {
		    let that = this;
		    if(that.planNameType == ''){
		        that.$utils.alertText('方案分类不能为空');
		        return;
		    }
			let data = {
				name:that.planNameType,
				id:that.planNameId
			}
		    that.$parent.loadModal(true,'正在提交数据...');
		    that.$api.post('monitor/scheme-type/update',{data:data},r =>{
				that.$parent.showLoad = false;
		        that.$utils.returnCode(r,function(){
		            that.getPlanList();
		            that.$refs.shieldModalFn.closeMask();
		        });
		    }); 
        },
        // 删除方案分类
		delPlanClassification (index,id){
			let that = this;
			that.$confirm('是否删除此分类？').then(() => {
				let data = {
					id:id
				}
				that.$parent.loadModal(true,'正在删除...');
				that.$api.post('monitor/scheme-type/del',{data:data},r =>{
					that.$parent.showLoad = false;
					that.$utils.returnCode(r,function(){
						that.$utils.alertText('删除成功！');
						that.getPlanList();
					})
				})
			})
        },
        // 打开方案多个关键词组的匹配信息弹框
        openKeywordsMatching(){
            let that = this;
            console.log(this.$parent.isPlan)
            if(this.$parent.isPlan.keywordsSelect){
                this.keywordsSelect = [...this.$parent.isPlan.keywordsSelect];
            }
            if(this.$parent.isPlan.keywordsMainSelect){
                this.keywordsMainSelect = [...this.$parent.isPlan.keywordsMainSelect];
            }
            this.$refs.keywordsMatch.showMaskFun();
        },
        // 方案多个关键词组的匹配信息
        keywordsMatching () {
            let that = this;
            if (this.keywordsMainSelect.length == 0 && this.$parent.isPlan.keywordsMain && this.$parent.isPlan.keywordsMain.length != 0) {
              this.$utils.alertText('请至少选择一个主题词')
              return
            }
            if (this.keywordsSelect.length == 0 && this.$parent.isPlan.keywordsFinal && this.$parent.isPlan.keywordsFinal.length != 0) {
              this.$utils.alertText('请至少选择一个分析词')
              return
            }
            that.$parent.loadModal(true,'正在提交数据...');
            let datas = {
                sid:that.$parent.isPlan.id,
                keywordsSelect:that.keywordsSelect,
                keywordsMainSelect:that.keywordsMainSelect
            }
            that.$api.post('monitor/scheme/keywords-select',{data:datas},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('设置成功');
                    location.reload();
                });           
            })
        },
        // 修改方案
        editPlan (id) {
            this.$refs.planModal.closeMask();
            this.$router.push({ path:'/analysis/buildSolution',query:{planId:id}})
        },
        // 搜索方案
        searchPlan (val) {
            if(val == ''){
                for(let item of this.planList){
                    if(this.$parent.isPlan.userId == item.typeId){
                        item.show = true;
                    }else{
                        item.show = false;
                    }
                    for(let child of item.schemeList){
                        if(this.$parent.isPlan.typeId == child.typeId){
                            child.show = true;
                        }else{
                            child.show = false;
                        }
                    }
                }
                this.planShowList = this.planList;
            }else{
                let planList = this.planList;
                let list = [];
                for(let child of planList){
                    let schemeList = [];
                    for(let i of child.schemeList){
                        let num = 0;
                        let arr1 = [];
                        for(let j of i.schemeList){
                            num++;
                            let name = j.name;
                            if(name.indexOf(val) != -1){
                                if(num === 1){
                                    
                                }
                                arr1.push(j)
                            }
                        }
                        if(arr1 != ''){
                            schemeList.push({
                                'typeName':i.typeName,
                                'typeId':i.typeId,
                                'schemeList':arr1,
                                'sort':i.sort,
                                'show':false
                            })
                        }
                    }
                    list.push({
                        'schemeList':schemeList,
                        'typeName':child.typeName,
                        'typeId':child.typeId,
                        'show':false
                    })
                }
                for(let item of list){
                    if(this.$parent.isPlan.userId == item.typeId){
                        item.show = true;
                    }else{
                        item.show = false;
                    }
                    for(let child of item.schemeList){
                        if(this.$parent.isPlan.typeId == child.typeId){
                            child.show = true;
                        }else{
                            child.show = false;
                        }
                    }
                }
                console.log(list)
                this.planShowList = list;
            }
        },
		allCheck(val) {
		  console.log(this.keywordsMainSelect,this.$parent.isPlan.keywordsMain)
		  if (val == 1) {
		    if (this.allMainList.indexOf('主体词') !== -1) this.$set(this, 'keywordsMainSelect', [...this.$parent.isPlan.keywordsMain])
		    else this.$set(this, 'keywordsMainSelect', [])
		  } else {
		    if (this.allMainList.indexOf('分析词') !== -1) this.$set(this, 'keywordsSelect', [...this.$parent.isPlan.keywordsFinal])
		    else this.$set(this, 'keywordsSelect', [])
		  }
		},
    },
    watch: {
        searchQuery (val) {
            this.searchPlan(val);    
        },
        $route(){
            let that = this;
            if(that.$route.meta.pageType == 5){
                that.reportPlanAjax();
            }
        },
		keywordsMainSelect: {
		  handler(n, o) {
		    if (!this.$parent.isPlan.keywordsMain) return
		    if (n.length == this.$parent.isPlan.keywordsMain.length && this.allMainList.indexOf('主体词') == -1) {
		      this.allMainList.push('主体词')
		    } else if (n.length !== this.$parent.isPlan.keywordsMain.length) {
		      this.$delete(this.allMainList, this.allMainList.indexOf('主体词'))
		    }
		  },
		  immediate: true
		},
		keywordsSelect: {
		  handler(n, o) {
		    if (!this.$parent.isPlan.keywordsFinal) return
		    if (n.length == this.$parent.isPlan.keywordsFinal.length && this.allMainList.indexOf('分析词') == -1) {
		      this.allMainList.push('分析词')
		    } else if (n.length !== this.$parent.isPlan.keywordsFinal.length) {
		      this.$delete(this.allMainList, this.allMainList.indexOf('分析词'))
		    }
		  },
		  immediate: true
		},
    }
}
</script>



// WEBPACK FOOTER //
// src/components/left.vue